// Fichier : pages/Admin/AjouterArticle.js
import React, { useState } from 'react';
import api from '../../api';
import RichTextEditor from '../../components/RichTextEditor';
import './AdminArticles.css';

const AjouterArticle = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [imageBase64, setImageBase64] = useState('');

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => setImageBase64(reader.result);
    if (file) reader.readAsDataURL(file);
  };

  /*const handleSubmit = async () => {
    try {
      await api.post('/articles', { title, content, imageBase64 });
      alert('Article ajouté avec succès');
      setTitle('');
      setContent('');
      setImageBase64('');
    } catch (err) {
      alert('Erreur lors de l’ajout');
    }
  };*/
  const handleSubmit = async () => {
    try {
      let imageUrl = '';
      let publicId = '';

      if (imageBase64) {
        const formData = new FormData();
        const blob = await fetch(imageBase64).then(res => res.blob());
        formData.append('image', blob, 'image.jpg');

        //const uploadRes = await api.post('/upload', formData);
        const uploadRes = await api.post('/upload/single', formData);
        imageUrl = uploadRes.data.url;
        publicId = uploadRes.data.public_id;
      }

      await api.post('/articles', {
        title,
        content,
        imageUrl,
        publicId
      });

      alert('Article ajouté avec succès');
      setTitle('');
      setContent('');
      setImageBase64('');
    } catch (err) {
      alert('Erreur lors de l’ajout');
      console.error(err);
    }
  };

  return (
    <div className="admin-page" style={{ textAlign: 'left' }}>
      <h2>Ajouter un article</h2>

      <input
        type="text"
        placeholder="Titre"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <RichTextEditor
        value={content}
        onChange={setContent}
        placeholder="Contenu de l'article"
      />

      <input type="file" onChange={handleImageChange} />

      <button onClick={handleSubmit}>Enregistrer</button>
    </div>
  );
};

export default AjouterArticle;
